export default class HotelNotificationMessage {
  static fromJSON (json) {
    return new HotelNotificationMessage({
      text: json.text,
      startDate: json.startDate,
      endDate: json.endDate,
      showPage: json.showPage
    })
  }

  constructor ({ text, startDate, endDate, showPage }) {
    this.text = text
    this.startDate = startDate || null
    this.endDate = endDate || null
    this.showPage = showPage || null
  }

  toBeShown () {
    if (!this.showPage) {
      return true
    } else if (this.showPage && this.showPage.toLowerCase().includes('bookingfunnel')) {
      const todayDate = new Date().getTime()
      const startDate = new Date(this.startDate).getTime()
      const endDate = new Date(this.endDate).getTime()
      return (!isNaN(startDate) && !isNaN(endDate) && todayDate >= startDate && todayDate <= endDate)
    }

    return false
  }
}
